export interface IModalMaintenanceHistory <T> {
    $event?: T;
    body?: T;
  }

export class ModalMaintenanceHistory<T> implements IModalMaintenanceHistory<T>{
    $event?: T;
    body?: T;
}